<template>
  <div class="wrap-comment wrap-bg f-tal">
    <div class="list-filter-wrap-box">
    <v-list-filter
      v-model="bindForms"
      :form-arr="formArr"
      :form-rules="formRules"
      :is-add-btn="false"
      form-item-position="row"
      class="list-filter bg-white"
      @changeFormBind="changeFormBind" />
    </div>
    <div class="wrap-main-content">
      <div class="mg-top15 f-df">
        <!-- 评论分布 -->
        <v-pie-chart
          :is-load="isLoading[0]"
          :pie-list="distributeList"
          :tip-txt="titleTxt[0].tipTxt"
          pie-legend-width='90px'
          id="distribute-pie-chart"
          title="评论分布">
          <span class="f-pa distribute-total f-fs14">
            评论总数：
            <em class="color-blue f-fs28 f-fwn">{{ distributeTotal }}</em>
          </span>
        </v-pie-chart>
        <!-- 评论趋势 -->
        <section class="mg-left15 pd15 bg-white flex-1">
          <v-title :tip-txt="titleTxt[1].tipTxt" title="评论趋势" class="f-pa chart-title-box" />
          <no-data v-if="isNodata[1] && !isLoading[1]" height="350" style="margin-top: 45px;" />
          <div
            v-show="!isNodata[1]"
            id="trend-line-chart"
            v-loading="isLoading[1]"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            class="chart-box trend-line-chart"
          ></div>
        </section>
      </div>
      <!-- 关注点 -->
      <div class="mg-top15 f-df">
        <!--评论关注点-->
        <section class="pd15 bg-white flex-1 focus-point-box">
          <v-title :tip-txt="titleTxt[2].tipTxt" title="评论关注点">
            <ol class="f-df f-ai pd-right20">
              <li
                v-for="(item, index) in tabList"
                :key="index"
                :class="item.id === tabActive.id ? 'active' : ''"
                class="f-df f-ai f-csp mg-left10 f-fs1 legend-item"
                @click="tabChange(item)">
                {{ item.name }}
              </li>
            </ol>
          </v-title>
          <no-data v-if="isNodata[2] && !isLoading[2]" height="350" style="margin-top: 45px;" />
          <div
            v-show="!isNodata[2]"
            id="focus-point-chart"
            v-loading="isLoading[2]"
            element-loading-text="加载中"
            element-loading-spinner="el-icon-loading"
            class="chart-box focus-point-chart pd-row15"
          ></div>
        </section>
        <section class="mg-left15 bg-white flex-1 detail-box">
          <v-title :tip-txt="titleTxt[3].tipTxt" title="评论明细" mg-btm="mg-btm30 f-ai" class="pd-top15 pd-left15">
            <span class="f-fs1 color-gray-76 mg-left20">{{ commentTag || tabActive.name }}（请点击左图切换）</span>
          </v-title>
          <no-data v-if="!detailList.length && !isLoading[2]" height="350" style="margin-top: 45px;" />
          <commentDetail
            v-else
            :is-loading="isLoading[3]"
            :time-all-list="detailList"
            :time-list="showDetailList"
            scrollDom=".detail-list"/>
        </section>
      </div>
      <!-- 交叉分析 -->
      <section class="cross-analysis bg-white mg-top15 pd15">
        <v-title :tip-txt="titleTxt[4].tipTxt" title="交叉分析" mg-btm="mg-btm20 f-jcsb"></v-title>
        <v-list-filter
          v-model="crossBindForm"
          :form-arr="crossFormArr"
          :is-add-btn="false"
          form-item-position="row"
          class="bg-white"
          @changeFormBind="crossFormChange" />
        <more-table
          v-loading="isLoading[4]"
          :is-load-detail='isLoadDetail'
          :table-head="crossTableHead"
          :table-list="crossList"
          :detail-list="crossDetailList"
          :show-detail-list="crossShowDetailList"
          :rowspanKey="rowspanKey"
          element-loading-text="加载中"
          element-loading-spinner="el-icon-loading"
          @crossDetail="crossDetail" />
      </section>
    </div>
  </div>
</template>

<script>
import pageConfig from './page.config.js'
import noData from '@/components/nodata.vue'
import vListFilter from '@/components/form-filter/index.vue'
import vTitle from '@/components/vTitle.vue'
import vPieChart from '@/components/chart/pie.vue'
import commentDetail from './components/commentDetail.vue'
import moreTable from './components/moreTable.vue'
import $filterCommon from '@/components/form-filter/index.js'
import mixin from '@/views/analysis/analysis.js'
import chartRender from '@/views/analysis/chartRender.js'
import {
  getAnalusisPie,
  getAnalysisTrend,
  getAnalysisAttention,
  getAnalysisDetail,
  getOverlapp
} from '@/api/analysis/comment.js'
export default {
  components: {
    noData,
    vListFilter,
    vTitle,
    vPieChart,
    commentDetail,
    moreTable
  },
  mixins: [mixin, chartRender],
  data() {
    return {
      isLoading: [false, false, false, false, false],
      isNodata: [false, false, false, false, false],
      titleTxt: pageConfig.titleTxt,
      bindForms: {},
      formArr: [],
      formRules: {},
      distributeList: [], // 评论分布
      distributeTotal: '', // 评论总数
      tabList: pageConfig.tabList, // 评论关注点 - 指标
      tabActive: {},
      focusPointList: [], // 评论关注点列表全部数据
      commentTag: '', // 当前哪个模块
      detailList: [], // 评论详情列表所有数据
      showDetailList: [], // 只展示部分评论详情列表
      crossBindForm: {},
      crossFormArr: [], // 交叉分析
      crossTableHead: [],
      crossList: [],
      pageObj: {
        page: 1,
        pageSize: 10,
        totalSize: 0,
        sortIndex: '', // issue_date按发布时间排序，impl_date按实施时间排序
        sortRule: '1' // 1倒序，2升序
      },
      isLoadDetail: false,
      crossShowDetailList: [],
      crossDetailList: [],
      rowspanKey: ''
    }
  },
  created() {
  },
  mounted() {
    this.tabActive = this.tabList[0].id
    // 初始化
    this.init()
  },
  methods: {
    init() {
      // 请求所有条件
      const filterAjaxList = JSON.parse(JSON.stringify(pageConfig.filterAjaxList))
      Promise.all(filterAjaxList.map(item => $filterCommon.getLabelCommon(item.method, item.url, item.param, item))).then(data => {
        const formArr = JSON.parse(JSON.stringify(pageConfig.filterForm))
        // 初始化所有筛选条件集合
        const filterObj = $filterCommon.filterChooseHandle(formArr, data)
        // 初始化当前选择的筛选条件
        const $storeFilter = this.$store.state.platParam
        this.bindForms = Object.assign(filterObj.filterChooseObj, $storeFilter)
        this.formArr = filterObj.filterList
        // 默认时间初始化，如果$store存在默认时间选择，优先选择，否则默认初始化的时间
        const timeChooseItem = this.formArr.find(item => item.id === ($storeFilter.timeType ? 'timeType' : 'dateMonth')) || {}
        this.changeFormBind(this.bindForms, timeChooseItem, $storeFilter.timeType || this.bindForms[timeChooseItem.intValue])
        // 页面统一请求初始化并且请求
        // const timeChooseItem = this.formArr.find(item => item.id === 'dateMonth') || {}
        // this.changeFormBind(this.bindForms, timeChooseItem, this.bindForms[timeChooseItem.intValue])
        // 交叉分析初始化
        this.crossInt()
      })
    },
    // 页面各个模块请求
    pageTotalAjax() {
      // 评论评价
      this.getDistributeData()
      // 评论趋势
      this.getTrendData()
      // 评论关注点
      this.tabActive = this.tabActive.id ? this.tabActive : this.tabList[0]
      this.getFocusPointData()
    },
    // 评论分布
    getDistributeData() {
      this.$set(this.isLoading, 0, true)
      getAnalusisPie(this.getParam()).then(res => {
        const result = res.data || {}
        this.distributeTotal = result.total
        this.$set(this.isLoading, 0, false)
        const colorArr = ['rgba(50, 108, 250, 1)', 'rgba(50, 108, 250, 0.8)', 'rgba(50, 108, 250, 0.6)', 'rgba(50, 108, 250, 0.4)', '#f2f2f2']
        const pieList = (result.dataList || []).map((item, index) => {
          return {
            name: item.name,
            color: colorArr[index % 5],
            sumKey: 'cnt',
            sum: item.cnt
          }
        })
        this.distributeList = pieList
      })
    },
    // 评论趋势
    getTrendData() {
      this.$set(this.isLoading, 1, true)
      this.$set(this.isNodata, 1, false)
      const param = this.paramTimeHandle(this.getParam())
      getAnalysisTrend(param).then(res => {
        this.$set(this.isLoading, 1, false)
        const data = res.data || []
        const isNodata = data.some(item => item.front * 1 !== 0 || item.negative * 1 !== 0 || item.neutral * 1 !== 0)
        // 所有数据都为0
        if (!isNodata) {
          this.$set(this.isNodata, 1, true)
          return
        }
        const seriesData = JSON.parse(JSON.stringify(pageConfig.seriesData))
        // const dataList = JSON.parse(JSON.stringify(pageConfig.trendList))
        const dataList = data.map(item => {
          item.dataTime = param.timeType * 1 === 0 ? item.dataTime.substr(0, 7) : item.dataTime
          return item
        })
        this.mixBarLineRender('trend-line-chart', 'dataTime', seriesData, dataList, '评论数')
      })
    },
    // 切换评论关注点正面以及负面
    tabChange(item) {
      this.tabActive = item
      // 初始化标签高亮
      this.commentTag = ''
      // 开始请求接口
      this.getFocusPointData()
    },
    // 评论关注点
    getFocusPointData() {
      this.$set(this.isLoading, 2, true)
      this.$set(this.isNodata, 2, false)
      getAnalysisAttention(Object.assign(this.getParam(), {
        commentType: this.tabActive.id
      })).then(res => {
        this.$set(this.isLoading, 2, false)
        // 正序
        const result = res.data || []
        if (!result.length) {
          this.$set(this.isNodata, 2, true)
          this.detailList = []
          this.showDetailList = []
          return
        }
        // const result = (res.data || []).reverse()
        // 总数
        const sum = result.reduce((sum, item) => {
          sum += item.value
          return sum
        }, 0)
        // 设置最小的矩形
        const setMinValue = sum * 1
        const dataList = result.map((item, index) => {
          const value = item.value || 0
          return {
            name: item.name + '(' + value + ')',
            sum: value,
            value: value < setMinValue ? setMinValue : value,
            label: item.name,
            itemStyle: {
              color: '#326CFA',
              borderWidth: 2,
              borderColor: '#fff',
              colorAlpha: index < 6 ? (1 - index * 0.15) : 0.3
            }
          }
        })
        const option = this.$chart.treemapChart(dataList)
        // 图形销毁重新绘制
        document.getElementById('focus-point-chart').removeAttribute('_echarts_instance_')
        // 重新绘制,重新加载数据
        const myChart = this.$echarts.init(document.getElementById('focus-point-chart'))
        myChart.setOption(option, true)
        // 根据屏幕的大小来缩放
        window.onresize = () => {
          myChart.resize()
        }
        // 绑定事件
        const _this = this
        myChart.on('click', param => {
          _this.getDetailByPoint(param.data.label)
        })
        // 请求评论详情列表
        this.getDetailByPoint()
      })
    },
    // 评论详情列表
    getDetailByPoint(name) {
      this.$set(this.isLoading, 3, true)
      this.commentTag = name || ''
      getAnalysisDetail(Object.assign(this.getParam(), {
        commentType: this.tabActive.id,
        commentTag: name || ''
      })).then(res => {
        this.$set(this.isLoading, 3, false)
        this.detailList = (res.data || []).map(item => {
          item.bgColor = '#326CFA'
          const markRedArr = item.highlight ? item.highlight.split(',') : []
          item.content = this.matchMarkLableHandle(markRedArr, item.commentText)
          return item
        })
        this.showDetailList = this.detailList.slice(0, 20)
        // 模拟数据
        this.crossDetailList = this.detailList
      })
    },
    // 匹配标注条件选择的字段高亮
    matchMarkLableHandle(markRedArr, txt) {
      if (!txt) return txt
      markRedArr.forEach(item => {
        if (!item) return
        const val = '<span class="color-highlight">' + item + '</span>'
        const pattern = /[`~!@#$%^&*()_+<>?:"{},.\/;'[\]]/im
        if (pattern.test(item)) {
          txt = txt.replace(item, val)
        } else {
          txt = txt.replace(new RegExp(item, 'g'), val)
        }
      })
      return txt
    },
    // 交叉分析初始化
    crossInt() {
      // 请求所有条件
      const filterAjaxList = JSON.parse(JSON.stringify(pageConfig.crossAjaxList))
      Promise.all(filterAjaxList.map(item => $filterCommon.getLabelCommon(item.method, item.url, item.param, item))).then(data => {
        data.push({
          id: 'row2Id',
          data: data[1].data
        }, {
          id: 'col2Id',
          data: data[0].data
        })
        const formArr = JSON.parse(JSON.stringify(pageConfig.crossFilter))
        // 初始化所有筛选条件集合
        const filterObj = $filterCommon.filterChooseHandle(formArr, data)
        // 初始化当前选择的筛选条件
        const crossBindForm = filterObj.filterChooseObj
        this.crossFormArr = filterObj.filterList
        // 页面统一请求初始化并且请求
        crossBindForm[this.crossFormArr[2].id] = this.crossFormArr[0].children[0].id
        crossBindForm[this.crossFormArr[3].id] = this.crossFormArr[1].children[1].id
        crossBindForm[this.crossFormArr[0].id] = this.crossFormArr[2].children[3].id
        crossBindForm[this.crossFormArr[1].id] = this.crossFormArr[3].children[4].id
        this.crossBindForm = crossBindForm
        this.crossFormChange(this.crossBindForm, this.crossFormArr[1], this.crossBindForm[this.crossFormArr[1].id])
      })
    },
    // 请求交叉分析表格
    getOverlappData() {
      let param = JSON.parse(JSON.stringify(this.crossFormBind))
      param.userId = this.$store.state.userInfo.userId
      if (param.row1Id === param.row2Id) param.row2Id = ''
      if (param.col1Id === param.col2Id) param.col2Id = ''
      this.crossFormArr.forEach((item, index) => {
        const key = item.id
        const newObj = {}
        const findItem = item.children.find(elem => elem.id === param[key]) || {}
        newObj[item.labelName] = findItem.labelName || ''
        newObj[item.indexName] = findItem.indexName || ''
        newObj[item.typeName] = findItem.type || ''
        param = Object.assign(param, newObj)
      })
      this.crossTableHead = []
      this.crossList = []
      this.$set(this.isLoading, 4, true)
      getOverlapp(param).then(data => {
        this.$set(this.isLoading, 4, false)
        const res = data.data || {}
        res.tableHead[0].fixed = false
        // res.tableHead[0].children[0].fixed = false
        // res.tableHead[0].children[1].fixed = false
        this.crossTableHead = res.tableHead || []
        this.crossList = (res.dataList || []).map(item => {
          for (const key in item) {
            item[key + '-isShow'] = false
            item[key + '-isLoad'] = true
          }
          return item
        })
        this.rowspanKey = this.crossTableHead[0].children ? this.crossTableHead[0].children[0].key : this.crossTableHead[0].key
      })
    },
    // 获取详情
    crossDetail(row, column) {
      row[column.property + '-isLoad'] = false
      row[column.property + '-isShow'] = false
      // row[column.property + '-isLoad'] = true
      // this.crossShowDetailList = []
      // setTimeout(() => {
      //   row[column.property + '-isLoad'] = false
      //   this.crossShowDetailList = this.crossDetailList.slice(Math.random() * 10, 20)
      // }, 1500)
    },
    // 行列修改
    crossFormChange(bindForms, item, value) {
      this.crossFormBind = bindForms
      this.getOverlappData()
    }
  }
}
</script>

<style lang="less" scoped>
@import '~@/assets/less/color.less';
.wrap-comment{
  & .distribute-total{
    top: 55px;
    left: 15px;
  }
  & .chart-title-box{
    z-index: 3;
  }
  & .chart-box{
    height: 100%;
  }
  & .focus-point-chart{
    width: 100%;
    height: calc(~'100% - 60px');
  }
  & .focus-point-box{
    height: 480px;
    min-width: 600px;
    & .legend-item{
      padding: 4px 15px;
      border: 1px solid @color-blue;
      border-radius: 15px;
      background-color: @color-white;
      color: @color-blue;
      &.active{
        background-color: @color-blue;
        color: @color-white;
      }
    }
  }
}
</style>
